import { DialogPortal } from '@tamman/ui-modal'
import { TabCatcher } from '@tamman/ui-utils'
import ContentPage from './pages/ContentPage'

import './styles/index.scss'

const App = () => {
  return (
    
    <TabCatcher>
      <main>
        <ContentPage />
      </main>
      <DialogPortal />
    </TabCatcher>
  )
}

export default App
